import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import { MdEdit, MdVisibility } from "react-icons/md"
import masterServices from '../../Services/masterService'
import { Modal } from '../../Components'
import ReactPaginate from 'react-paginate'
import Loader from '../../Components/Loader';
import { useLocation } from 'react-router-dom'
import CheckAccess from '../../Function/CheckAccess'

let currentPage1 = 1
export const WarehouseList = () => {
    const history = useHistory()
    const [listData, setListData] = useState([]);
    const [pagination, setPagination] = useState({ page: 1, limit: 10 })
    const [currentPage, setCurrentPage] = useState(currentPage1)
    const [loader, setLoader] = useState(true)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isDeleteOpen, setIsDeleteOpen] = useState(false)

    const location = useLocation()
    let user_type = localStorage.getItem("user_type")

    useEffect(() => {
        getItemList()
        // eslint-disable-next-line
    }, [currentPage])

    const getItemList = () => {
        let param = { ...pagination, page: currentPage }
        if (pagination.search) {
            param['page'] = 1
        }
        masterServices.get_warehouse(param).then(res => {
            if (res.status) {
                setLoader(false)
                setListData(res.data)
                setPagination({ ...pagination, ...res.pagination })
            } else {
                setLoader(false)
            }
        })
    }

    const onPageChangeEvent = (e) => {
        currentPage1 = e.selected + 1
        setLoader(true)
        setCurrentPage(e.selected + 1)
    }

    const onModalSubmit = () => {
        let postData = {
            id: isModalOpen._id,
            status: isModalOpen.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE',
        };
        masterServices.update_warehouse_status(postData).then(res => {
            if (res.status) {
                setIsModalOpen(false)
                // setIsDeleteOpen(false)
                getItemList();
            }
        })
    }

    const onDeleteSubmit = () => {
        let postData = {
            id: isDeleteOpen._id,
            is_delete: 'YES'
        }

        masterServices.delete_warehouse(postData).then(res => {
            if (res.status) {
                setIsDeleteOpen(false)
                getItemList()
            }
        })
    }

    return (

        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between mb-3">
                            {/* <div>
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder="Search..."
                                />
                            </div> */}
                            <div className="input-group pl-3 w-25">
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="search..."
                                    onChange={(e) => setPagination({ ...pagination, search: e.target.value })}
                                    onKeyPress={(e) => e.key === 'Enter' && getItemList()}
                                    onKeyUp={(e) => ((e.key === 'Backspace') && (pagination.search.length <= 0)) && getItemList()}
                                ></input>
                                <div className="input-group-prepend">
                                    <button className="input-group-text pointer search-btn" onClick={() => getItemList()} style={{ backgroundColor: '#e5e4ec' }}>
                                        search
                                    </button>
                                </div>
                            </div>
                            {
                                (CheckAccess(222,"add") ||  user_type === "SUPERADMIN" )&& 
                            <button className="btn btn-primary btn-sm w-sm waves-effect waves-light"
                                onClick={() => history.push('/add-warehouse')}
                            >Add Warehouse
                            </button>
                            }
                        </div>
                        <div className="table-responsive">
                            <table className="table table-centered table-nowrap mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>S no.</th>
                                        <th>Name</th>
                                        <th>Short Name</th>
                                        <th>Address</th>
                                        <th>Ownership</th>
                                        <th>Remarks</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>

                                </thead>
                                <tbody>
                                    {listData.length > 0 && listData.map((list, key) => (
                                        <tr key={key}>
                                            <td className="text-body fw-bold">{((pagination.page - 1) * pagination.limit) + (key + 1)}</td>
                                            <td>{list.name}</td>
                                            <td>{list.short_name}</td>
                                            <td>{list.address}</td>
                                            <td>{list.ownership}</td>
                                            <td>{list.remarks}</td>
                                            <td>
                                                <span
                                                    className={"badge rounded-pill font-size-12 pointer" + (list.status === 'ACTIVE' ? ' bg-success' : ' bg-soft-danger')}
                                                    onClick={() => setIsModalOpen(list)}
                                                >
                                                    {list.status}
                                                </span>
                                            </td>

                                            <td>  <MdVisibility
                                                    className="pointer"
                                                    onClick={() => history.push('/warehouse-detail?id=' + list._id, list)}
                                                    color="#0323fe"
                                                    size="25px"
                                                />
                                                {
                                                     (CheckAccess(222,"edit") || user_type === "SUPERADMIN") && 
                                                <MdEdit
                                                    className="pointer"
                                                    onClick={() => history.push('/edit-warehouse?id=' + list._id, list)}
                                                    color="#0323fe"
                                                    size="25px"
                                                />
                                                }
                                                {/* <MdDeleteForever
                                                    className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                                                    className="pointer"
                                                    color="red"
                                                    size="25px"
                                                    onClick={() => setIsDeleteOpen(list)}
                                                /> */}

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {listData.length <= 0 && !loader &&
                                <div className="text-center w-100 bg-warning my-5">
                                    <h6 className="py-2"> list not available </h6>
                                </div>
                            }
                        </div>
                    </div>
                    {listData.length > 0 && pagination.totalRecord > pagination.limit &&
                        <ReactPaginate
                            previousLabel={<img src="assets/images/prev.svg" height={15} alt="not found" />}
                            forcePage={currentPage - 1}
                            nextLabel={<img src="assets/images/next.svg" height={15} alt="not found" />}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={3}
                            onPageChange={(e) => onPageChangeEvent(e)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    }
                    {Boolean(isModalOpen) &&
                        <Modal.ChangeStatus
                            isOpen={Boolean(isModalOpen)}
                            title='Update Status'
                            message={`Are you sure want to ${isModalOpen.status === 'ACTIVE' ? 'Inactive' : 'Active'} status ?`}
                            onSubmitEvent={() => onModalSubmit()}
                            handleClose={() => setIsModalOpen(false)}
                        />
                    }
                    {Boolean(isDeleteOpen) &&
                        <Modal.DeleteItem
                            isOpen={Boolean(isDeleteOpen)}
                            title='Delete'
                            message={`Are you sure want to Delete`}
                            onSubmitEvent={() => onDeleteSubmit()}
                            handleClose={() => setIsDeleteOpen(false)}
                        />
                    }
                </div>
                <Loader isShow={loader} />
            </div>
        </div>
    )
}
